var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPizza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1435 40.7789L40.4718 28.451C43.6033 26.3445 45.1689 25.2915 45.4534 23.3738C45.7379 21.4562 44.7096 20.1675 42.653 17.5902C37.9331 11.6753 31.5207 7.26585 24.1852 5.15976C21.3943 4.35846 19.9988 3.95782 18.5028 4.80701C17.0069 5.65619 16.5187 7.31392 15.5425 10.6294L9.54737 30.9903C6.74268 40.5156 5.34033 45.2784 7.68655 47.1016C10.0328 48.9249 14.0697 46.2096 22.1435 40.7789Z",
    stroke: "#009595",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10.8334C16.25 10.8334 17.4156 11.0895 19.2836 11.6599C25.2031 13.4673 30.483 16.9711 34.6667 21.6669",
    stroke: "#009595",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1862 23.8334H28.1667",
    stroke: "#009595",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6143 17.2328C15.9454 17.8719 17.429 20.0024 17.429 22.5916C17.429 26.2038 13.9191 28.9646 10.4524 27.98",
    stroke: "#009595",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0041 36.819C27.3624 34.338 25.2637 32.519 22.7739 32.519C19.7738 32.519 17.3418 35.1598 17.3418 38.4174C17.3418 40.1433 18.0245 41.6961 19.1126 42.7747",
    stroke: "#009595",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPizza);
export default __webpack_public_path__ + "static/media/ic_pizza.2ceeb50b84c5dfc67dc242af5f02c601.svg";
export { ForwardRef as ReactComponent };